import styled from 'styled-components';

import { IOffice } from '../../common/model/office.model';
import useI18n from '../../common/hooks/useI18n';
import { OfficesRowContainer } from './';

type Props = {
  offices: IOffice[];
  className?: string;
};

const Title = styled.h2`
  ${(props) => props.theme.font.h2}
  text-align: center;
  color: ${(props) => props.theme.colors.secondary};
  font-size: 38px !important;
  @media ${(props) => props.theme.breakpoints.sm} {
    font-size: 32px !important;
  }
  @media ${(props) => props.theme.breakpoints.xs} {
    font-size: 26px !important;
  }
`;

const Divider = styled.div`
  border: 1px solid ${(props) => props.theme.colors.primary};
  background-color: ${(props) => props.theme.colors.primary};
  border-radius: ${(props) => props.theme.borderRadius};
  width: 64px;
  margin-top: 16px;
  margin-bottom: 24px;
  margin-left: auto;
  margin-right: auto;
`;

const OfficesSection: React.FC<Props> = ({ offices, className }) => {
  const i18n = useI18n();

  return (
    <div id="officesSection" className={className}>
      <Title>{i18n.t('officesSection.title')}</Title>
      <Divider />
      <OfficesRowContainer offices={offices} />
    </div>
  );
};

export default styled(OfficesSection)`
  background-color: white;
  padding-top: 56px;
`;
